import React, { FunctionComponent, memo } from 'react'

import styled from 'styled-components'
import { SpaceProps, space, WidthProps, width } from 'styled-system'

import { Radio } from '@/atoms/input'
import { filterLayoutProps } from '@/helpers/styled-props'
import { SelectOption } from '@/models/common'

interface Props {
  vertical?: boolean
  options: Array<SelectOption>
  hasError?: boolean
  onClick: (value: string) => void
  selectedValue: string
  name?: string
  fieldProps?: SpaceProps & WidthProps
  optionProps?: SpaceProps & WidthProps
  disabled?: boolean
}

const RadioGroup: FunctionComponent<Props> = ({
  vertical,
  options,
  hasError,
  onClick,
  selectedValue,
  name,
  fieldProps,
  optionProps,
  disabled,
}: Props) => (
  <Group $vertical={vertical} {...fieldProps}>
    {options &&
      options.map(({ label, value: optionValue }, index) => (
        <Radio
          id={`${name}_${index}`}
          key={`${name}_${index}`}
          name={name}
          value={optionValue as string}
          radioLabel={label as string}
          selected={selectedValue === optionValue}
          hasError={hasError}
          onClick={onClick}
          vertical={vertical}
          optionProps={optionProps}
          disabled={disabled}
        />
      ))}
  </Group>
)

const Group = styled.div.withConfig({
  shouldForwardProp: filterLayoutProps(),
})<{ $vertical?: boolean } & SpaceProps & WidthProps>`
  display: flex;
  flex-direction: ${({ $vertical }) => ($vertical ? 'column' : 'row')};
  flex-wrap: wrap;
  width: 100%;

  ${space}
  ${width}
`

export default memo(RadioGroup)
